import React from "react";
import { BoxIcon } from "lucide-react";
interface MedallionProps {
  icon: BoxIcon;
  className?: string;
}
export function Medallion({
  icon: Icon,
  className = ''
}: MedallionProps) {
  return <span className={`inline-flex h-16 w-16 items-center justify-center rounded-full border border-accent/40 bg-accent/10 ${className}`} aria-hidden="true" data-id="element-157" data-mp="1zbqyo7zazzuw">
      <Icon className="h-7 w-7 text-accent" strokeWidth={1.6} data-id="element-158" data-mp="249ac55o6g8ls" />
    </span>;
}